import React, { useContext, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { ensureConnectionAndExecute } from "../../utils/eph-connection-manager";
import { pollTaskStatus } from "../../utils/taskStatus";

export default function UpdateProfileExperience({ data }) {

  const [updateExperience, setUpdateExperience] = useState(false);
  const { URI } = useContext(UrlContext);


  function decodeJwt(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64).split('').map(c =>
          '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        ).join('')
      );
      return JSON.parse(jsonPayload);
    } catch (err) {
      console.error("❌ Failed to decode token:", err);
      return null;
    }
  }

  const updateExperienceHandler = async () => {
    setUpdateExperience(true);
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    const decodedToken = decodeJwt(token);
    // const url = `http://localhost:5005/helper/update-experience`;
    const url = `${URI}helper/update-experience`;

    try {
      const result = await ensureConnectionAndExecute(
        "update_experience",
        async () => {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
            body: JSON.stringify({ "token": decodedToken?.preferred_username, "profile_url": data.link, "profile_id": data.id }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          return await response.json();
        }
      );

      if (!result) {
        throw new Error("No response received from server");
      }

      if (result.status === "error") {
        if (result.message === "User not connected") {
          Swal.fire({
            icon: "error",
            title: "User not connected!",
            text: "Please refresh the page and update the project list on the extension!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        return;
      }

      if (result.status === "queued") {
        const finalState = await pollTaskStatus(URI, result.task_id, token, {
          timeoutMs: 90000,
          intervalMs: 3000,
        });

        if (finalState.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Experience updated successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
        } else if (finalState.status === "timeout") {
          Swal.fire({
            icon: "warning",
            title: "Timeout",
            text: "The extension did not confirm completion in time. Please verify in the extension and try again.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Update failed",
            text: finalState.error || "The extension reported an error while updating the experience.",
          });
        }
        return;
      }

      if (result.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Experience updated successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Experience update error:", error);
      Swal.fire({
        icon: "error",
        title: "Connection Error",
        text: error.message || "Failed to update experience",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setUpdateExperience(false);
    }
  };

  return (
    <>
      <button
        className="btn updateExperience"
        onClick={() => updateExperienceHandler()}
      >
        <i className="fa fa-pencil" /> Update Experience
      </button>

      {updateExperience && (
        <div className="addToZoho-popup-wrapper">
          <div className="tab-pane fade show addToZoho-div">
            <center>
              <p style={{ fontSize: "18px" }}>Updating Experience...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>

      )}
    </>
  );
}
